import { api } from './api';

// TalentCompetency (TCO-A) — Competency Profile catalog.
// All profiles are GLOBAL CTH templates. No company_id scoping.
export const competencyProfileApi = {
  list: (params = {}) =>
    api.get('/admin/competency-profiles', { params }).then((r) => r.data),
  get: (id) =>
    api.get(`/admin/competency-profiles/${id}`).then((r) => r.data),
  create: (body) =>
    api.post('/admin/competency-profiles', body).then((r) => r.data),
  update: (id, body) =>
    api.patch(`/admin/competency-profiles/${id}`, body).then((r) => r.data),
  transition: (id, to_status, note) =>
    api.post(`/admin/competency-profiles/${id}/transition`, { to_status, note }).then((r) => r.data),
  catalogCompetencies: () =>
    api.get('/admin/competency-profiles/catalog/competencies').then((r) => r.data),
  catalogQuestionnaires: () =>
    api.get('/admin/competency-profiles/catalog/questionnaires').then((r) => r.data),
};

// Admin-side competency requests inbox (TCO-B).
export const competencyRequestAdminApi = {
  list: (params = {}) =>
    api.get('/admin/competency-requests', { params }).then((r) => r.data),
  get: (id) =>
    api.get(`/admin/competency-requests/${id}`).then((r) => r.data),
  assign: (id, body) =>
    api.post(`/admin/competency-requests/${id}/assign`, body).then((r) => r.data),
  reject: (id, reason) =>
    api.post(`/admin/competency-requests/${id}/reject`, { reason }).then((r) => r.data),
  fulfill: (id, competency_profile_id) =>
    api.post(`/admin/competency-requests/${id}/fulfill`, { competency_profile_id }).then((r) => r.data),
};

// Client-side competency requests (TCO-B).
export const competencyRequestClientApi = {
  list: (params = {}) =>
    api.get('/client/competency-requests', { params }).then((r) => r.data),
  get: (id) =>
    api.get(`/client/competency-requests/${id}`).then((r) => r.data),
  create: (body) =>
    api.post('/client/competency-requests', body).then((r) => r.data),
  selfAssign: (body) =>
    api.post('/client/competency-requests/self-assign', body).then((r) => r.data),
  cancel: (id) =>
    api.post(`/client/competency-requests/${id}/cancel`).then((r) => r.data),
  listPublishedProfiles: () =>
    api.get('/client/competency-profiles').then((r) => r.data),
};
